module.exports = {
  ENV: 'prod',
  APP_NAME: 'dioneo',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'AvrnCQJt9Z9SoBoTZo5nxcPxMngAaLg7QwrctEa7',
  BRAND_KEY: '3b375c31-9863-4af1-9bb9-1b30a76b7ebe',
  LANG: 'fr-FR'
}